import comp from "./ReportItem";
export default comp;
